import React from "react";
import Meal from "./Meal";


import loader from '../images/gif/loading-gear.gif'

export default function MealList({ allMeals, loading }) {
  if (loading) {
    return <h2 className="text-white w-1/2 mx-auto mt-2 ">
      <img className="bg-white rounded h-10 mx-auto" src={loader} alt="loading" />
    </h2>;
  }
  if (allMeals.length<1) {
    return (
      <h2 className="bg-red-700 text-white text-center font-bold w-1/2 mx-auto rounded my-5 ">
        no meal matched your search criteria
      </h2>
    );
  }
  return (
    <section className="bg-purple-900 sm:w-full h-full flex flex-col items-center justify-center ">
      <h2 className="text-white text-3xl font-mono h-5 p-2 ">Meals</h2>
      <div className="flex flex-col my-10 mx-auto shadow-lg w-full h-full bg-white text-gray-900 rounded">
        {allMeals.map(item => {
          return <Meal key={item.id} {...item} />;
        })}
      </div>
    </section>
  );
}
